import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const CustomIOSSwitch = styled((props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    display: "flex",
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transition: "transform 300ms ease-in-out",
      "&.Mui-checked": {
        transform: "translateX(16px) !important",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#de6b14",
          opacity: 1,
          border: 0,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#de6b14",
        border: "6px solid #fff",
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
      transition: "all 300ms ease-in-out !important",
    },
    "& .MuiSwitch-track": {
      borderRadius: 13,
      backgroundColor: "#ccc",
      opacity: 1,
      transition: "background-color 300ms ease-in-out !important",
    },
  }));

export default CustomIOSSwitch;